module.exports = __webpack_public_path__ + "img/H2.0433c8a8.png";